import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { Box } from '@mui/material';

export default function CustomDrawer({ children, open, onToggle }) {
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={() => onToggle(false)}
      sx={{
        height: '100%',
        width: '100%',
        position: 'absolute',
       
        zIndex: 9999999,
        '& .MuiDrawer-paper': {
          borderRadius: '16px 0 0 16px', // Rounded corners on the left side
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
          backgroundColor: '#fff', // Background color
          padding: '16px', // Padding inside the drawer
          overflow: 'hidden', // Prevent overflow
        },
      }}
    >
      <Box sx={{ height: '100%', overflowY: 'auto'  }}>
        {children}
      </Box>
    </Drawer>
  );
}
